import ExperimentsListRoute from './ExperimentsListRoute';

export default ExperimentsListRoute;
